<template>
  <div  class="s-progress-bar-comp">
    <!-- TODO: Link up DATA -->
    <div  class="s-progress-bar"
      role=""
      :style="'width: ' + progressBarWidth + '%;'"
      aria-valuenow="25"
      aria-valuemin="0"
      aria-valuemax="100">
    </div>
  </div>
</template>

<script>
export default {
  props: {
    progressBarWidth: {
      type: Number,
      default: 0,
    }
  }
}
</script>

<style lang="scss"></style>
